import $ from "jquery";


/**
 * Comme les vidéos sont lues dans une modale, si on ferme cette modale
 * alors que la vidéo est en cours de lecture, on entend encore le son de la vidéo (qui continue sa lecture).
 * L'astuce ici est de supprimer l'attribut src à la fermeture de la modale et de le rajouter tout de suite après.
 */
const init_embed_video_in_modal = () => {
    var myModalsEl = document.getElementsByClassName("modal modal-embed");
    [...myModalsEl].forEach((el, index) =>{
        el.addEventListener('hidden.bs.modal', (e) => {
            const modalId = e.currentTarget.id,
                modal = $(`#${modalId}`),
                iframe = modal.find('iframe'),
                iframeUrl = modal.data('iframeurl');
            ;
            iframe.attr("src", "");
            iframe.attr("src", iframeUrl);
        });
    })
}

export {init_embed_video_in_modal}